import VTabs from './VTabs.vue';
import VTab from './VTab.vue';
import VTabItems from './VTabItems.vue';
import VTabItem from './VTabItem.vue';

export { VTabs, VTab, VTabItems, VTabItem };
export default { VTabs, VTab, VTabItems, VTabItem };
